import AFrequentlyUsedContactButton from './index.vue';

AFrequentlyUsedContactButton.install = app => {
  app.component(AFrequentlyUsedContactButton.name, AFrequentlyUsedContactButton);
};

export default AFrequentlyUsedContactButton;
